export default __webpack_public_path__ + "static/media/dropdown.64d09982.svg";